//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import payPublic from '@/javascript/payPublic'

    export default {
        name: 'vueUpload',
        props: {
            maxNum: Number,
            maxSize: Number,
            typeKind: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                imgList: [],
                limit: this.maxNum,
                userinfo: {},
                userId: '',
                userToken: ''
            }
        },
        mounted() {
            this.userinfo = JSON.parse(sessionStorage.getItem('userInfo'))
            this.userId = JSON.parse(sessionStorage.getItem('userInfo')).user.id
            this.userToken = JSON.parse(sessionStorage.getItem('userInfo')).access_token
        },
        methods: {
            showWin() {
                alert('最多可上传' + this.maxNum + '张图片')
            },
            chooseType() {
                document.getElementById('upload_file').click()
            },
            fileChange(el) {
                if (!el.target.files[0].size) return
                for (let i = 0; i < el.target.files.length; i++) {
                    let value = el.target.files[i].size
                    if (value > 1024000 * this.maxSize) {
                        alert('图片不能大于' + this.maxSize + 'M')
                        return
                    }
                }
                this.fileList(el.target)
                el.target.value = ''
            },
            fileList(fileList) {
                let files = fileList.files
                for (let i = 0; i < files.length; i++) {
                    // 判断是否为文件夹
                    if (files[i].type != '') {
                        this.fileAdd(files[i])
                    } else {
                        // 文件夹处理
                        this.folders(fileList.items[i])
                    }
                }
            },
            folders(files) {
                let _this = this
                // 判断是否为原生file
                if (files.kind) {
                    files = files.webkitGetAsEntry()
                }
                files.createReader().readEntries(function (file) {
                    for (let i = 0; i < file.length; i++) {
                        if (file[i].isFile) {
                            _this.foldersAdd(file[i])
                        } else {
                            _this.folders(file[i])
                        }
                    }
                })
            },
            foldersAdd(entry) {
                let _this = this
                entry.file(function (file) {
                    _this.fileAdd(file)
                })
            },
            fileAdd(file) {
                const _this = this
                _this.addImgfun(file)
            },
            addImgfun(file) {
                if (this.limit !== undefined) this.limit--
                if (this.limit !== undefined && this.limit < 0) {
                    this.showWin()
                    return
                }
                // 总大小
                this.size = this.size + file.size
                // 判断是否为图片文件
                if (file.type.indexOf('image') == -1) {
                    alert('请选择图片文件')
                } else {
                    let reader = new FileReader()
                    let image = new Image()
                    let _this = this
                    reader.readAsDataURL(file)
                    reader.onload = function () {
                        file.src = this.result
                        const postData = {
                            'base64Code': file.src,
                            'format': file.type.split('/')[1]
                        }
                        _this.$http.post('/api/zuul/wtcp-material/uploads/base64ToImg/toc/' + _this.userId, postData).then((response) => {
                            if (response.data.status === 1) {
                                if (_this.typeKind == "appFor") {
                                    image.onload = function () {
                                        let width = image.width
                                        let height = image.height
                                        file.width = width
                                        file.height = height
                                        _this.imgList.push({
                                            file
                                        })
                                    }
                                    image.src = file.src
                                    _this.$emit("on-file-add", response.data.data)
                                } else {
                                    const array = new Array()
                                    array.push(response.data.data)
                                    _this.$http.post('/api/wtcp-comment/evaluationAttachment?access_token=' + _this.userToken, array).then((response) => {
                                        if (response.data.status === 1) {
                                            image.onload = function () {
                                                let width = image.width
                                                let height = image.height
                                                file.width = width
                                                file.height = height
                                                _this.imgList.push({
                                                    file
                                                })
                                            }
                                            image.src = file.src

                                            _this.$emit("on-file-add", response.data.data)
                                        } else {
                                            alert('图片保存失败')
                                        }
                                    })
                                }
                            } else {
                                alert('图片上传失败')
                            }
                        })
                    }
                }
            },
            delImg(index) {
                this.size = this.size - this.imgList[index].file.size     // 总大小
                this.imgList.splice(index, 1)
                if (this.limit !== undefined) {
                    this.limit = this.maxNum - this.imgList.length
                }
                this.$emit("on-file-del", index)
            }
        }
    }
